import Swiper from "swiper"
import { Navigation, Mousewheel, Pagination } from "swiper/modules"

const implementedProjectsSliderEl = document.querySelector(
	".implemented-projects__slider.swiper"
)
if (implementedProjectsSliderEl) {
	new Swiper(".implemented-projects__slider", {
		modules: [Navigation, Mousewheel],
		slidesPerView: "auto",
		spaceBetween: 24,
		watchOverflow: true,
		mousewheel: {
			sensitivity: 1,
			forceToAxis: true,
		},
		navigation: {
			prevEl: ".implemented-projects__slider-prev",
			nextEl: ".implemented-projects__slider-next",
		},
		breakpoints: {
			320: {
				spaceBetween: 16,
			},
			600: {
				spaceBetween: 16,
			},
			1024: {
				spaceBetween: 24,
			},
		},
	})
}

const tasksSliderEl = document.querySelector(".tasks-slider__slider")
if (tasksSliderEl) {
	new Swiper(".tasks-slider__slider", {
		modules: [Navigation, Mousewheel],
		slidesPerView: "auto",
		spaceBetween: 24,
		watchOverflow: true,
		mousewheel: {
			sensitivity: 1,
			forceToAxis: true,
		},
		navigation: {
			prevEl: ".tasks-slider__slider-prev",
			nextEl: ".tasks-slider__slider-next",
		},
		breakpoints: {
			320: {
				spaceBetween: 8,
			},
			600: {
				spaceBetween: 12,
			},
			1024: {
				spaceBetween: 20,
			},
		},
	})
}

if (window.innerWidth <= 480) {
	const aboutCardsSwiper = new Swiper(".about__cards", {
		modules: [Mousewheel],
		slidesPerView: "auto",
		spaceBetween: 16,
		watchOverflow: true,
		mousewheel: {
			sensitivity: 1,
			forceToAxis: true,
		},
	})
}

if (window.innerWidth <= 600) {
	const advantagesSliderEl = document.querySelector(".advantages__slider")
	if (advantagesSliderEl) {
		new Swiper(".advantages__slider", {
			modules: [Navigation, Pagination, Mousewheel],
			slidesPerView: "auto",
			spaceBetween: 20,
			watchOverflow: true,
			mousewheel: {
				sensitivity: 1,
				forceToAxis: true,
			},
			navigation: {
				prevEl: ".advantages__slider-prev",
				nextEl: ".advantages__slider-next",
			},
			pagination: {
				el: ".advantages__slider-dots",
				clickable: true,
				bulletClass: "slider-nav__dot",
				bulletActiveClass: "slider-nav__dot--active",
				renderBullet: (index, className) =>
					`<button class="${className}"></button>`,
			},
		})
	}

	const teamSliderEl = document.querySelector(".team__slider")
	if (teamSliderEl) {
		new Swiper(".team__slider", {
			modules: [Navigation, Pagination, Mousewheel],
			slidesPerView: "auto",
			spaceBetween: 20,
			watchOverflow: true,
			mousewheel: {
				sensitivity: 1,
				forceToAxis: true,
			},
			navigation: {
				prevEl: ".team__slider-prev",
				nextEl: ".team__slider-next",
			},
			pagination: {
				el: ".team__slider-dots",
				clickable: true,
				bulletClass: "slider-nav__dot",
				bulletActiveClass: "slider-nav__dot--active",
				renderBullet: (index, className) =>
					`<button class="${className}"></button>`,
			},
		})
	}
}

if (window.innerWidth <= 768) {
	const employeesSliderEl = document.querySelector(".employees__slider")
	if (employeesSliderEl) {
		new Swiper(".employees__slider", {
			modules: [Mousewheel],
			slidesPerView: "auto",
			spaceBetween: 24,
			watchOverflow: true,
			mousewheel: {
				sensitivity: 1,
				forceToAxis: true,
			},
		})
	}

	const aboutSegmentsSliderEl = document.querySelector(".about-segments__slider")
	if (aboutSegmentsSliderEl) {
		new Swiper(".about-segments__slider", {
			modules: [Mousewheel],
			slidesPerView: "auto",
			spaceBetween: 16,
			breakpoints: {
				601: {
					spaceBetween: 20,
				},
			},
			watchOverflow: true,
			mousewheel: {
				sensitivity: 1,
				forceToAxis: true,
			},
		})
	}
}